import { render, staticRenderFns } from "./QAReview.vue?vue&type=template&id=646a56cc&"
import script from "./QAReview.vue?vue&type=script&lang=js&"
export * from "./QAReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports